import React, { useRef } from "react";
import { Card } from "react-bootstrap";
import Chart from "react-apexcharts";
import { GraphCardsHeader } from "@ui";

function BasicLineChart({
  title,
  series,
  labels,
  height = 300,
  yaxisTitle = "",
  tooltip = "",
}) {
  const chartRef = useRef(null);

  async function downloadPNG() {
    const chartInstance = chartRef.current;
    const base64 = await chartInstance.chart.dataURI();
    const downloadLink = document.createElement("a");
    downloadLink.href = base64.imgURI;
    downloadLink.download = "image.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  function exportCSV() {
    let csvContent = "Date," + series.map((s) => s.name).join(",") + "\n";
    labels.forEach((category, index) => {
      let row = [category];

      series.forEach((series) => {
        row.push(series.data[index]);
      });
      csvContent += row.join(",") + "\n";
    });
    var blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    if (link.download !== undefined) {
      var url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", "chart_data.csv");
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  function downloadChart() {
    const chartInstance = chartRef.current;
    if (chartInstance) {
      downloadPNG(chartInstance);
    } else {
      console.error(`Chart not found.`);
    }
  }

  const chartOptions = {
    series: series || [],
    options: {
      chart: {
        height: 380,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      colors: ["#13388C", "#159A6C", "#156078"],
      dataLabels: {
        enabled: false,
        style: {
          colors: ["#000"],
          fontSize: "12px",
          fontFamily: "Poppins, Arial, sans-serif",
          fontWeight: "bold",
        },
      },
      legend: {
        show: true,
        position: "bottom",
        showForSingleSeries: true,
        offsetY: 5,
        markers: {
          width: 10,
          height: 10,
          radius: 50,
          shape: "circle",
        },
        itemMargin: {
          horizontal: 10,
        },
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      markers: {
        size: 4,
      },
      xaxis: {
        categories: labels || [],
        tickAmount: 6,
        style: {
          fontFamily: "Poppins, Arial, sans-serif",
        },
      },
      yaxis: [
        {
          title: {
            text: yaxisTitle,
            style: {
              fontSize: "12px",
              fontFamily: "Poppins, Arial, sans-serif",
              fontWeight: "600",
            },
            offsetX: 0,
          },
          min: 0,
        },
      ],
    },
  };

  return (
    <Card className="flex-grow-1 d-flex flex-column mb-0">
      <GraphCardsHeader
        title={title}
        tooltip={tooltip}
        showDownloadButtons={true}
        needImageDownload={true}
        needCSVDownload={true}
        downloadCSV={exportCSV}
        downloadImage={downloadChart}
      />
      <Card.Body className="flex-grow-1">
        <div id="chart">
          <Chart
            options={chartOptions.options}
            series={chartOptions.series}
            type="line"
            height={height}
            ref={chartRef}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default BasicLineChart;
